import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')
const directories = (state) => _.get(state, 'directories')
const directory = (state) => _.get(state, 'directory')
const pageDirectory = (state) => _.get(state, 'pageCount.directory')
const pageDirectories = (state) => _.get(state, 'pageCount.directories')


export default {
	isLoading,
	directory,
	directories,
	pageDirectories,
	pageDirectory
}
